import { faArrowDown, faArrowUp, faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import 'antd/dist/antd.css'
import { Select } from 'antd'
import axios from 'axios';
import api from '../../config.json'
import swal from 'sweetalert';

const MoveableTable = ({ reportTypes, handleOnChange, reportData }) => {
    const [rows, setRows] = useState([{ FieldName: "", DataType: "", EnableMultiSelect: false }]);
    const [newRowName, setNewRowName] = useState('');
    const [fields, setFields] = useState([]);
    const [errors, setErrors] = useState({})

    useEffect(() => {
        getAllFields()
    }, [])
    console.log(rows, "vbjnvijdfn")
    useEffect(() => {
        setRows(reportData.CustomFields || [{ FieldName: "", DataType: "", EnableMultiSelect: false }]);
    }, [reportData])



    const getAllFields = () => {
        axios.get(api.api + "CustomField")
            .then((result) => {
                console.log(result, "custom fields api data");
                result.data = result.data.map((one) => { return { label: one.FieldName, value: one.FieldName, _id: one._id, type: one.DataType } })
                setFields(result.data)
            })
            .catch((err) => {
                swal(`${err}`);
            })
    }

    const moveRowUp = (index) => {
        if (index === 0) return; // Can't move up the first row
        const newRows = [...rows];
        [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];
        handleOnChange({ target: { name: "CustomFields", value: newRows } })
        setRows(newRows);
    };

    const moveRowDown = (index) => {
        if (index === rows.length - 1) return; // Can't move down the last row
        const newRows = [...rows];
        [newRows[index + 1], newRows[index]] = [newRows[index], newRows[index + 1]];
        handleOnChange({ target: { name: "CustomFields", value: newRows } })
        setRows(newRows);
    };

    const addRow = () => {
        const newRow = { FieldName: "", DataType: "", EnableMultiSelect: false };
        setRows([...rows, newRow]);
        setNewRowName('');
    };

    const deleteRow = (index) => {
        const newRows = rows.filter((row, i) => i !== index);
        handleOnChange({ target: { name: "CustomFields", value: newRows } })
        setRows(newRows);
    };

    const handleInputChange = (index, event) => {
        const data = [...rows];
        data[index][event.target.name] = event.target.value;
        handleOnChange({ target: { name: "CustomFields", value: data } })
        setRows(data);
    }

    return (
        <div>
            <Form>
                <Row className="mt-3">
                    <Col sm={4}>
                        <Select
                            // maxTagCount='responsive'
                            //mode="multiple"
                            placeholder="Select Inspection Type"
                            value={reportData.ReportType || []}
                            // value={row.FieldName}
                            onChange={(values, all) => {
                                // handleInputChange(index, { target: { name: 'Field', value: values.value } })
                                handleOnChange({ target: { name: 'ReportType', value: values } })
                            }}
                            style={{ width: '100%' }}
                            options={reportTypes}
                        />
                    </Col>
                    {/* <Col>
                        <Button onClick={addRow}>Add Row</Button>
                    </Col> */}
                </Row>
            </Form>
            <Table className='mt-2' striped bordered hover>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Data Type</th>
                        <th>Enable Multi Select</th>
                        <th>Position</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={row.id}>
                            <td>

                                <Select
                                    // maxTagCount='responsive'
                                    //mode="multiple"
                                    placeholder="Select Field"
                                    value={row.FieldName}
                                    onChange={(values, all) => {
                                        handleInputChange(index, { target: { name: 'FieldName', value: values } })
                                        handleInputChange(index, { target: { name: 'DataType', value: all.type } })
                                    }}
                                    style={{ width: '100%' }}
                                    options={fields}
                                />

                                {errors.FieldName && <div className="alert small alert-danger">{errors['FieldName']}</div>}
                            </td>
                            <td>{row.DataType}</td>
                            <td><input disabled={!(row.DataType == 'list')} checked={row.EnableMultiSelect || false} type='checkbox' onChange={(e) => handleInputChange(index, { target: { name: 'EnableMultiSelect', value: e.currentTarget.checked } })} name='EnableMultiSelect' /></td>
                            <td>
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => moveRowUp(index)}
                                    disabled={index === 0}
                                >
                                    <FontAwesomeIcon icon={faArrowUp} />
                                </Button>{' '}
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => moveRowDown(index)}
                                    disabled={index === rows.length - 1}
                                >
                                    <FontAwesomeIcon icon={faArrowDown} />
                                </Button>{' '}
                            </td>
                            <td>
                                {rows.length > 1 && <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => deleteRow(index)}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </Button>}
                                {(index == rows.length - 1) && <Button
                                    className='ml-1'
                                    // variant="danger"
                                    size="sm"
                                    onClick={() => addRow()}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} />
                                </Button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default MoveableTable;
